import Vue from 'vue';
import Component from 'vue-class-component';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class TestComponent extends Vue {
    mounted() {
        window.document.title = 'Test';
    }
}
